module.exports = __webpack_public_path__ + "img/login-santarosa.a5b4d754.svg";